"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_BOUNDING_BOXES = void 0;
var client_1 = require("@apollo/client");
exports.UPDATE_BOUNDING_BOXES = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation UpdateBoundingBoxes($input: UpdateBoundingBoxesInput!) {\n    updateBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"], ["\n  mutation UpdateBoundingBoxes($input: UpdateBoundingBoxesInput!) {\n    updateBoundingBoxes(input: $input) {\n      status\n    }\n  }\n"])));
var templateObject_1;
